import { AppRouteProps } from "@mzara/component";
import { ProjectKanbanDetailsInformationsContainer } from "./container/ProjectKanbanDetailsInformationsContainer";

export const ProjectKanbanDetailsInformationsRoutes: Array<AppRouteProps> = [
    {
        path: 'edit',
        element: <ProjectKanbanDetailsInformationsContainer />
    }
]